import React, { useEffect, useState } from "react";
import {Box, Link, List, ListItem, Typography} from "@mui/material";

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}

const renderDocs = (docs) => (
        <Box mt={6}>
            <List>
                {docs.map((doc, index) => (
                    doc.head ? (
                        <ListItem key={index}>
                            <Typography variant="h6">{doc.name}</Typography>
                        </ListItem>
                    ) : (
                        <ListItem key={index}>
                            <Link href={doc.href}>
                                {doc.name}
                            </Link>
                        </ListItem>
                    )
                ))}
            </List>
        </Box>
    );


export default useIsMobile;
export {renderDocs};